import { render, staticRenderFns } from "./IncomesExpensesSettings.vue?vue&type=template&id=764236c2&scoped=true&"
import script from "./IncomesExpensesSettings.vue?vue&type=script&lang=js&"
export * from "./IncomesExpensesSettings.vue?vue&type=script&lang=js&"
import style0 from "./IncomesExpensesSettings.vue?vue&type=style&index=0&id=764236c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764236c2",
  null
  
)

export default component.exports